import React, { useEffect } from "react";
import { Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createIssuerDomainMapping, viewIissuerDomainMapping, resetView } from "../actions/issuerDomainMap.actions";
import HorizontalForm from "./components/Form";
import PageHeader from "../../../shared/components/PageHeader";

const IssuerDomainMapForm = ({ dispatch, mapping, match, domains, issuers, history }) => {
    const createFormData = (mapping) => {
        
        let formData;
        const hasMapping = match.params.domainCode && mapping && mapping.response && mapping.response.data && mapping.response.data.length;
    
        const mappingObj = hasMapping ? mapping.response.data[0] : null;
      
        if (match.params.domainCode) {
            formData = {
                domains: match.params.domainCode,
                scpIssuers: match.params.issuerCode,
                issuerNr: mappingObj && mappingObj.issuerNr ? mappingObj.issuerNr : 0,
                bankCode: mappingObj && mappingObj.bankCode ? mappingObj.bankCode : null,
                reportPrefix: mappingObj && mappingObj.reportPrefix ? mappingObj.reportPrefix : null,
            };
        } else {
            if (mappingObj) {
                formData = {
                    domains: getDomainObject(mappingObj.domainCode),
                    scpIssuers: getIssuerObject(mappingObj.issuerCode),
                    issuerNr: mappingObj.issuerNr,
                    bankCode: mappingObj.bankCode,
                    reportPrefix: mappingObj && mappingObj.reportPrefix ? mappingObj.reportPrefix : null,
                };
            }
        }

        
        return formData;
    };

    function getDomainObject(domainCode) {
        
        const domainObject = !!domains && domains.length && domains.find((domain) => domain.code === domainCode);
       
        return domainObject;
    }

    function getIssuerObject(issuerCode) {
        const issuerObject = !!issuers && issuers.length && issuers.find((issuer) => issuer.issuerCode.trim(" ") === issuerCode);
        return issuerObject;
    }

    function fetchMapping() {
        dispatch(viewIissuerDomainMapping(match.params.domainCode));
    }

    const addIssuerDomainMapping = (values) => {
        if (match.params.domainCode && match.params.issuerCode) {
           
            let issuerName = mapping && mapping.response && mapping.response.data && mapping.response.data[0] && mapping.response.data[0].issuerName;
            let formatData = {
                issuerCode: match.params.issuerCode,
                issuerName,
                ...values,
            };
           
            dispatch(createIssuerDomainMapping(formatData, match.params.domainCode,history));
        } else {
            dispatch(createIssuerDomainMapping(values));
        }
    };

    useEffect(() => {
      
        if (match.params.domainCode) {
            
            dispatch(viewIissuerDomainMapping(match.params.domainCode));
        }

        return () => {
            dispatch(resetView());
        };
    }, [dispatch, match.params.domainCode]);

    return (
        <Container>
            <PageHeader header="Map Issuers" subheader="Manage Issuer Mapping for domains" />
            <Row>
                <HorizontalForm domainCode={match.params.domainCode} mapping={mapping} fetchData={fetchMapping} initialValues={createFormData(mapping)} onSubmit={addIssuerDomainMapping} />
            </Row>
        </Container>
    );
};

export default connect((state) => ({
    mapping: state.getIssuerDomainMapping,
    domains: state.domains && state.domains.response,
    issuers: state.scpIssuers && state.scpIssuers.response && state.scpIssuers.response.data,
}))(withRouter(IssuerDomainMapForm));
